/*
 * Copyright (c) 2024 Pegasystems Inc.
 * All rights reserved.
 */
import { C11nEnv } from '../../interpreter/c11n-env';
import AnnotationsHandler from '..';
import ContextProcessor from '../../context/context-processor';
import type { NodeProps } from '../../contextree/types';

AnnotationsHandler.registerHandler(
  '@USER',
  (propertyRef: string, c11nEnv: C11nEnv, contextTreeNodeProps: NodeProps = {}) => {
    const userId =
      c11nEnv?.getValue(propertyRef) || ContextProcessor.getLitePropertyValue(contextTreeNodeProps, propertyRef);
    const user = c11nEnv?.getReferencedUser(userId) || ContextProcessor.getReferencedUser(userId, contextTreeNodeProps);
    return {
      userId,
      userName: user ? user.UserName : null
    };
  }
);
